// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/global.css
// module id = 658
// module chunks = 12